import type { MergeabilityStatus } from './get-mergeability-status.server';

export type PendingMergeabilityStatus = {
  // The API returns this while the PR mirror is repairing missing branch/ruleset metadata.
  status: 'pending';
  // Set when the server knows this viewer's pending state cannot resolve within this mount
  // (non-member reads never trigger mirror repair), so polling should stop immediately.
  terminal?: boolean;
  // Consecutive pending responses in the current pending episode. Stored on the cached payload
  // (not query.state.dataUpdateCount, a lifetime counter that realtime invalidations and
  // mutations also increment) so the poll budget resets whenever the status resolves.
  attempt?: number;
};

export type MergeabilityStatusResponse = MergeabilityStatus | PendingMergeabilityStatus;

export function isPendingMergeabilityStatus(
  data: MergeabilityStatusResponse | undefined,
): data is PendingMergeabilityStatus {
  return Boolean(data && 'status' in data && data.status === 'pending');
}
